export default __webpack_public_path__ + "static/media/2025-man-painter-1.41695e38.png";